import request from "./request.js";

export default {
  // 登录
  getTestTable: (data) => {
    return request({
      url: "api/admin/test/showTestTable/" + data,
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  addTest: (data) => {
    return request({
      url: "api/admin/test/addTest",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateTest: (data) => {
    return request({
      url: "api/admin/test/updateTest",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  getAlTests: () => {
    return request({
      url: "api/admin/test/getAllTests",
      method: "get",
    }).then((res) => {
      return res.data;
    });
  },
};
